module.exports = __webpack_public_path__ + "assets/img/load-assist.b313faf4.png";